import PieChart from '@/charts/PieChart';
import * as Styles from './OriginChart.styles';
import ChartHeader from '../ChartHeader';
import Loading from '../general/Loading';

type OriginChartComponentProps = {
  title: string;
  total: number;
  data: any;
  colors: string[];
  onSelectFilter: (value: string) => void;
  periodOptions: any[];
  isLoading: boolean;
};

const OriginChartComponent = function ({
  title,
  total,
  data,
  colors,
  onSelectFilter,
  periodOptions,
  isLoading,
}: OriginChartComponentProps): JSX.Element {
  // Chart style
  const style = {
    height: '160px',
    marginLeft: '-32px',
    marginRight: '-32px',
  };

  // Chart options
  const option = {
    title: {
      text: `${total} total`,
      left: 'center',
      top: 'center',
      textStyle: {
        color: '#ccc',
      },
    },
    tooltip: {
      trigger: 'item',
    },
    series: [
      {
        name: title,
        type: 'pie',
        radius: ['60%', '70%'],
        emphasis: {
          label: {
            show: true,
          },
        },
        color: colors,
        labelLine: {
          show: true,
        },
        data,
      },
    ],
  };

  return (
    <Styles.CustomChartCard data-testid="origin-chart">
      <div>
        <ChartHeader
          onSelectFilter={onSelectFilter}
          filterOptions={periodOptions}
          title="Origin"
          tooltipMessage="This chart displays the total number of new candidates created on the selected date divided by their origin, if they were sourced by Trio, have applied to a job opening or were referred to us by someone."
        />
        <div>
          {isLoading ? (
            <div style={style}>
              <Loading size={25} sx={{ marginTop: 9 }} />
            </div>
          ) : (
            <PieChart option={option} style={style} className="pie-chart" />
          )}
        </div>
      </div>
    </Styles.CustomChartCard>
  );
};

export default OriginChartComponent;
